'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'puzzle';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e443';
var svgPathData = ['M48 288l48 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 64 0 0 64-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 48L48 464l0-176z', 'M512 0l0 208-80 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16-64 0 0-64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-80L512 0zM0 240L0 64l224 0 0 80 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 80-64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-48 0 0 176 176 0 0-48-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-64 80 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 80 0 0 224-192 0-32 0L24 512 0 512l0-24L0 288l0-48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPuzzle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;